import React, { useEffect } from 'react';
import useSelector from 'hooks/useSelector';
import SubHeader from "components/menu/SubHeader";
import { Card } from "reactstrap";
import Loading from './Loading';

export default () => {
    const profile = useSelector(state => state.profile);

    useEffect(() => {

    }, [profile]);

    return (
        <>
            {profile ?
                < div className="narrow-container" >
                    <SubHeader />

                    <Card className="primary-card">
                        <h2>No access</h2>

                        <h3>You do not have access to this page</h3>
                    </Card>
                </div >
                :
                <Loading />
            }
        </>
    );
}
